import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const APPROVE_USER_SUCCESS = "APPROVE_USER_SUCCESS";

export interface ApproveUserSuccessAction extends Action {
  type: typeof APPROVE_USER_SUCCESS;
  organization: OrganizationKeyName;
  userId: number | string;
}

export const approveUserSuccessAction = (
  organization: OrganizationKeyName,
  userId: number | string
): ApproveUserSuccessAction => ({
  type: APPROVE_USER_SUCCESS,
  organization,
  userId,
});
